import styled from 'styled-components'

import Sizes from './ProgressChart.sizes'
import { colors } from '../../constants'

export const Wrapper = styled.div`
    display: block;
    width: 100%;
`

export const Bar = styled.div`
    background: ${colors.bluedark};
    height: 50px;
    position: relative;
    width: 100%;

    ${({ size }) => size && `height: ${Sizes[size]};`}
`

export const Progress = styled.div`
    background: ${colors.bluelight};
    height: 100%;
    transition: width 0.5s;

    ${({ value }) => `width: ${value * 100}%;`}
`

export const PercentageContainer = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    padding: 0 15px;
    position: absolute;
    top: 0;
    width: 100%;
`

export const Percentage = styled.span`
    color: ${colors.white};
`

export const OpponentPercentage = styled.span`
    color: ${colors.white};
`

export const Labels = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 15px;
`

export const Label = styled.div`
    font-size: 14px;
    font-weight: bold;
`
